import React from 'react';
import CustomerLogo from '../CampaignLogo/CampaignLogo';
import CustomerLogoImage from '../../assets/images/logo-brand-customer.svg';
import FooterMenu from '../Navigation/FooterMenu/FooterMenu';
import classes from './Footer.module.scss';

import { Row, Col } from 'reactstrap';

const FooterContent = (props) => (
    <Row className="w-100 m-0 align-items-center">
        <Col lg="2" className="d-flex align-items-center order-last order-lg-first">
            <CustomerLogo linkUrl={process.env.REACT_APP_CUSTOMER_URL} src={CustomerLogoImage} />
        </Col>

        <Col
            lg="10"
            className="d-flex align-items-center justify-content-lg-end justify-content-start order-first order-lg-last"
        >
            <FooterMenu secondaryNavigation={props.secondaryNavigation} />
        </Col>
    </Row>
);

const footer = (props) => (
    <footer className={classes.Footer}>
        {props.contained ? (
            <div className="container-lg p-0">
                <FooterContent {...props} />
            </div>
        ) : (
            <div className="container-fluid p-0">
                <FooterContent {...props} />
            </div>
        )}
    </footer>
);

export default footer;
